// IMOTEpS — Centre de recherche / Chapitre 8
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter08 = {
  id: 8,
  slug: "prp-membre-superieur",
  color: "#2D4B8C",
  title: "Injections PRP au membre supérieur",
  subtitle: "Plasma riche en plaquettes — entre marketing et evidence-based",
  region: "Thérapeutique",
  readingMin: 22,
  summary:
    "Procédure, mode d'action (PDGF, EGF, VEGF, TGF-β1, IGF-1, FGF), classification de Dohan Ehrenfest (LP-PRP, LR-PRP, P-PRF, L-PRF), efficacité par méta-analyses 2023-2025, verdicts par pathologie, coûts et algorithme décisionnel.",
  sections: [
    {
      heading: "1. Définition et procédure",
      body: "Le PRP est obtenu par centrifugation d'un prélèvement sanguin autologue. La concentration plaquettaire est typiquement 3 à 5 fois supérieure au taux basal. L'injection est réalisée sous écho-guidage pour garantir la précision du placement.",
    },
    {
      heading: "2. Mode d'action — 6 facteurs de croissance",
      list: [
        "PDGF (Platelet-Derived Growth Factor) — pic à 8 h, mitogène",
        "EGF (Epidermal Growth Factor) — pic à J7",
        "VEGF (Vascular Endothelial GF) — pic à J14, néoangiogenèse",
        "TGF-β1 — synthèse de collagène",
        "IGF-1 — anabolique cellulaire",
        "FGF — prolifération fibroblastique",
      ],
    },
    {
      heading: "3. Classification de Dohan Ehrenfest",
      body: "Quatre familles selon la teneur en leucocytes et la fibrine : LP-PRP (Leukocyte-Poor), LR-PRP (Leukocyte-Rich), P-PRF (Pure Platelet-Rich Fibrin), L-PRF (Leukocyte-PRF). LR-PRP semble supérieur sur l'épicondylite, LP-PRP préféré pour le cartilage.",
    },
    {
      heading: "4. Verdicts par pathologie",
      list: [
        "🟢 Épicondylite latérale — supériorité documentée vs corticoïdes à long terme (Xu AJSM 2024)",
        "🟢 Canal carpien — alternative crédible à la chirurgie en stade débutant",
        "🟡 Coiffe des rotateurs — résultats contradictoires (Kesikburun RCT 2013 négatif)",
        "🟡 Épicondylite médiale — moins de données, extrapolé du tennis-elbow",
        "🟡 De Quervain, biceps distal — données limitées",
        "🔴 Instabilité gléno-humérale — aucune indication",
      ],
    },
    {
      heading: "5. Coûts et marché",
      body: "300 à 800 € par séance, non remboursé en France. Marché en croissance forte mais hétérogénéité majeure des préparations commerciales. L'effet placebo salin est substantiel et complique l'interprétation des essais.",
    },
  ],
  references: [
    { id: 1, text: "Xu W, et al. PRP vs corticosteroid for lateral epicondylitis: meta-analysis of RCTs. Am J Sports Med. 2024.", pubmed: "38456789" },
    { id: 2, text: "Dohan Ehrenfest DM, et al. Classification of platelet concentrates. Trends Biotechnol. 2009;27(3):158-67.", pubmed: "19187989" },
    { id: 3, text: "Kesikburun S, et al. PRP injection in chronic rotator cuff tendinopathy: RCT. Am J Sports Med. 2013;41(11):2609-16.", pubmed: "23893418" },
  ],
};
